import { FetchMonthlyBillsAPIResponse, Gstr1SummaryReportAPIResponse } from '../../../services/monthlyBills'
import { BaseReducerState, GSTR1Report } from '../../../services'
import { ActionTypes } from '../actions'

export type FetchGSTR1State = BaseReducerState & {
  data: GSTR1Report
}

export const initialState: FetchGSTR1State = {
  loading: false,
  success: false,
  message: '',
  data: null,
  error: null,
}

export const fetchGstr1 = (
  state: FetchGSTR1State = initialState,
  action: { type: string; res: any }
): FetchGSTR1State => {
  switch (action.type) {
    case `${ActionTypes.FETCH_GSTR1_JSON}_REQUEST`:
      return {
        ...state,
        loading: true,
        success: false,
        message: null,
        data: null,
        error: null,
      }

    case `${ActionTypes.FETCH_GSTR1_JSON}_SUCCESS`: {
      const { success, data, message } = <Gstr1SummaryReportAPIResponse>action.res
      return {
        ...state,
        loading: false,
        success,
        message,
        ...(success && data && { data }),
      }
    }
    case `${ActionTypes.FETCH_GSTR1_JSON}_FAILURE`:
      const res = <Gstr1SummaryReportAPIResponse>action.res
      const { message } = res || {}
      res.error ??= message
      const { error } = res
      return {
        ...state,
        loading: false,
        success: false,
        message,
        error,
      }

    case `${ActionTypes.FETCH_GSTR1_JSON}_RESET`:
      return {
        ...initialState,
      }
  }
  return state
}
